import React from 'react';
import { Link, useParams } from 'react-router-dom';


function AddBreadCrumb() {
  const { id, plantName } = useParams(); // assuming /cogendashboard/:id route

  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">Add Plant's Performance Data</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={`/cogendashboard/${plantName.replace(
                    /\s+/g,
                    "-"
                  )}/${id}`} className="breadcrumb-link">Cogeneration Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/performance-data/${plantName.replace(
                    /\s+/g,
                    "-"
                  )}/${id}`} className="breadcrumb-link">Cogeneration Plant's Performance Data</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add Plant's Performance Data
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default AddBreadCrumb;
